"use client";

import { useEffect } from "react";
import { progress } from "@/services/nprogress";

export default function Loading() {
  useEffect(() => {
    // Inicia com anti-flicker (caso ainda não tenha iniciado pelo clique/popstate)
    progress.intentStart();

    // Finaliza no unmount — timing perfeito do fim do carregamento
    return () => {
      progress.forceDone();
    };
  }, []);

  return null;
}
